import { joinClasses } from "@/utils/styling"

interface RadioSelectProps<
    TOption extends Record<string, string>,
    TValueKey extends keyof TOption = "Value",
    TTextKey extends keyof TOption = "Text"
> extends React.InputHTMLAttributes<HTMLInputElement> {
    type?: Exclude<React.HTMLInputTypeAttribute, "checkbox" | "text" | "range">;
    id: string;
    options: TOption[];
    optionValueKey?: TValueKey;
    optionTextKey?: TTextKey;
}

export default function RadioSelect<
    TOption extends Record<string, string>,
    TValueKey extends keyof TOption = "Value",
    TTextKey extends keyof TOption = "Text"
>({
    id,
    options,
    optionValueKey,
    optionTextKey,
    ...attributes
}: RadioSelectProps<TOption, TValueKey, TTextKey>) {
    const valueKey = (optionValueKey ?? "Value") as TValueKey;
    const textKey = (optionTextKey ?? "Text") as TTextKey;

    return (
        <>
            {options.map((x, i) =>
                <div key={`${id}${x[valueKey]}`} className={joinClasses("form-check form-check-inline", i > 0 ? "ms-3" : undefined)}>
                    <input className="form-check-input" type="radio" id={`rb${id}${x[valueKey]}`} value={x[valueKey]} key={x[valueKey]} {...attributes} />
                    <label className="form-check-label" htmlFor={`rb${id}${x[valueKey]}`}>{x[textKey]}</label>
                </div>
            )}
        </>
    );
}